import AddTagDropdown from "./AddTagDropdown";
import { ClientTag } from "@avenueops/shared-types";
import { Button, Popover, PopoverTrigger, PopoverContent } from "@avenueops/web-components";
import { PlusSmallIcon } from "@heroicons/react/24/outline";

interface Props {
  currentTags: ClientTag[] | Pick<ClientTag, "id" | "name" | "color">[];
  parentObject: { type: "WORKFLOW" | "PROCESS" | "WORKFLOW_BULK_ACTION"; ids: string[] };
  workflowId?: string;
  size?: "SMALL" | "MEDIUM" | "LARGE";
}

export default function AddTagButton({ currentTags, parentObject, workflowId, size = "MEDIUM" }: Props) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button type="SECONDARY" LeadIcon={PlusSmallIcon} size={size}>
          Add Tag
        </Button>
      </PopoverTrigger>
      <PopoverContent className="px-2">
        <AddTagDropdown workflowId={workflowId} currentTags={currentTags} parentObject={parentObject} />
      </PopoverContent>
    </Popover>
  );
}
